var homepage4i = (function () {
	var homeScroller = document.getElementById("mainSlider"),	
	
	homepageSlider = (function(){
		var pauseIcon = "<svg class='textDkGray' width='30' height='30' focusable='false'><title>Pause Animation</title> <use xlink:href='#svgIcon-pause'></use> </svg>",
		playIcon = "<svg class='textDkGray rotate90' width='30' height='30' focusable='false'><title>Pause Animation</title> <use xlink:href='#svgIcon-arrowSolid'></use> </svg>",
		animationBtn = document.getElementById("pausePlayBtn"),
		homeSlider,
		
		init = function(){
			homeSlider = tns({ 
				container: ".homeSlider",
				autoplay: true,
				speed: 1000,
				autoplayTimeout: 5500,
				lazyload: false, 
				controls: false,
				autoplayHoverPause: true,
				autoplayPosition: "top",
				autoplayButton: "#pausePlayBtn",
				autoplayText: [
				    playIcon,
				    pauseIcon
				]
			});
			homeScroller.classList.remove("invisible"); // slider is set up
			setTabindex();
			homeSlider.events.on('transitionStart', setTabindex);
			animationBtn.addEventListener("click", toggleAriaPressed);
		},
		toggleAriaPressed = function(e){
			e.preventDefault();
			if (animationBtn.getAttribute("aria-pressed") == "false"){
				animationBtn.setAttribute("aria-pressed", "true");
			} else{
				animationBtn.setAttribute("aria-pressed", "false");
			}
		},
		setTabindex = function(){
			// set the active slide button to tabindex 0 and the rest to -1 so they cannot be tabbed to
			var slides = [].slice.call(homeScroller.querySelectorAll(".tns-item"));
			slides.forEach(function(el, index, array){
				el.querySelector("a").setAttribute("tabindex", "-1");
			});
			homeScroller.querySelector(".tns-slide-active").querySelector("a").setAttribute("tabindex", "0");
		};
		return{
			Init: init
		};
	})(),
	
	newsletterForm = (function(){
		var newsSignUpBtn = document.getElementById("signUpBtn"),
		emailForm = document.getElementById("signUpForm"),
		emailInput = document.getElementById("signUpEmail"),
		emailError = document.getElementById("signUpError"),
		
		init = function(){
			newsSignUpBtn.addEventListener("click", function(e){
				e.preventDefault();
				submitForm();
		    	});
			newsSignUpBtn.addEventListener( "keyup", function(e){
				if(e.keyCode == 13){ newsSignUpBtn.click(); }
			});
		},
		submitForm = function(){
			// validate the email address, reusing the regex from registration
			var loading = '<div id="emailLoading" class="spinner" role="alert" aria-atomic="true" aria-label="Loading, please wait"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div>';
			var filter;
			if (document.getElementById('hdnEmailRegex')){
				filter = new RegExp(document.getElementById('hdnEmailRegex').value);
			}else {
			       filter = /^([\w-&amp;+\'\.]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-zA-Z\-]{2,24}(?:\.[a-zA-Z\-]{2})?)$/i;
				//filter = /^([\w-&]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,66}(?:\.[a-z]{2})?)$/i;
				
			}
			if (emailInput.value === "" || emailInput.value === undefined || !filter.test(emailInput.value)) {
				// invalid, show the error message and highlight the textbox
				showEmailError();
			} else {
				// valid, submit via AJAX
				newsSignUpBtn.classList.add("hide"); // hide btn and show loading img to prevent double submit and give a visual indicator to the user
				newsSignUpBtn.insertAdjacentHTML("afterend", loading);				
				showEmailSuccess();
			}		
	    	},
	    	showEmailError = function(){
			emailInput.classList.add("input-validation-error");
			emailInput.setAttribute("aria-invalid", "true");
			emailInput.removeAttribute("aria-labelledby");
			emailInput.focus();
			emailError.classList.remove("hide");
			emailError.textContent = "Please enter a valid email address";
		},
		showEmailSuccess = function(){
			var headerToken = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
			fetch('/esp/signup', { 
				method: 'POST', 
	        		credentials: 'same-origin',
				body: JSON.stringify({ EmailAddress: emailInput.value }), 
				headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'fetch', '__RequestVerificationToken': headerToken }
			}).then(function(response){
				return  (response.ok) ? response.json() : [];
			}).then(function(response){
				if (response.success === 'true') {
					document.getElementById("emailLoading").parentNode.removeChild(document.getElementById("emailLoading"));
	                        	emailForm.classList.add("hide");
	                        	emailForm.insertAdjacentHTML("afterend", '<div class="clear text16" role="alert" aria-atomic="true"><div class="displayFlex flexNoWrap"><svg class="textGreen marginRight5" height="25px" width="25px" aria-hidden="true"><use xlink:href="#svgIcon-checkMarkBox"></use></svg><p class="text16 textsemibold">Success! ' + emailInput.value + ' has been signed up!</p></div><a id="emailOpts" class="marginTop10" href="/esp/subscriptionsmanager/' + response.email + '">View all our email options</a></div>');
	                        	setTimeout(function(){ // screen reader not reading success message if focus is set immediately
	                        		document.getElementById("emailOpts").focus();
	                        	}, 200);
				} else {
					document.getElementById("emailLoading").parentNode.removeChild(document.getElementById("emailLoading"));
					emailError.classList.remove("hide");
					emailError.textContent = "Oops, something went wrong. Please submit again.";
					emailInput.focus();
					newsSignUpBtn.classList.remove("hide");
				}
			}).catch(function(error){
				document.getElementById("emailLoading").parentNode.removeChild(document.getElementById("emailLoading"));
				emailError.classList.remove("hide");
				emailError.textContent = "Oops, something went wrong. Please submit again.";
				emailInput.focus();
				newsSignUpBtn.classList.remove("hide");
			});
		};
		return{
			Init: init
		};
	})(),
	
	init = function(){
		homepageSlider.Init();
		newsletterForm.Init();
	};
	
    	return {
    		Init: init
    	};
})();

(function(){
	homepage4i.Init();
})();